import DarkCardComponent from "../../components/dark-card/dark-card";
import "./expertise-page.css";

import WebIcon from "@mui/icons-material/Web";
import AppsIcon from "@mui/icons-material/Apps";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import DnsIcon from "@mui/icons-material/Dns";
import HardwareIcon from "@mui/icons-material/Hardware";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards, Pagination, Autoplay } from "swiper/modules";

function ExpertiseAreaPage() {
  const expertise = [
    {
      title: "Web Development (Full-Stack)",
      icon: WebIcon,
      description:
        "Confident in MEAN and MERN Stacks. Expertise in Styling and making responsive web pages.",
    },
    {
      title: "UI / UX",
      icon: AppsIcon,
      description: "UI designs created using Figma and experience in UX.",
    },
    {
      title: "Desktop Application Development (Full-Stack)",
      icon: PersonalVideoIcon,
      description:
        "Familiar with Java and JavaFX desktop applications and .NET developments.",
    },
    {
      title: "Mobile Application Development (Full-Stack)",
      icon: SmartphoneIcon,
      description:
        "React Native developments using android studio and Apple mobile device application developments using x-code.",
    },
    {
      title: "Web Hosting",
      icon: DnsIcon,
      description:
        "Full-stack and frontend only web pages hosted in Azure, Google App Engine, Vercel, Github Pages.",
    },
    {
      title: "Computer Hardware",
      icon: HardwareIcon,
      description:
        "Computer repairing, dismantling and fixing. Finding Computer hardware issues etc.",
    },
  ];
  return (
    <div id="expertise">
      <div className="expert-main">
        <div className="global-title" data-aos="fade-up">
          Expertise and Skills
        </div>
        <div className="global-subtitle" data-aos="fade-up">
          A Comprehensive Overview of My Professional Abilities
        </div>

        <div className="expert-container">
          <div className="expert-items">
            {expertise.map((expert) => (
              <DarkCardComponent
                key={expert.title}
                title={expert.title}
                icon={<expert.icon style={{ color: "var(--purple_c)" }} />}
                description={expert.description}
              />
            ))}
          </div>
        </div>

        <div className="expert-container-mobile">
          <div className="expert-items-mobile" data-aos="fade-up">
            <Swiper
              effect={"cards"}
              grabCursor={true}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2600,
                disableOnInteraction: true,
              }}
              modules={[EffectCards, Pagination, Autoplay]}
              className="expertSwiper"
            >
              {expertise.map((expert) => (
                <SwiperSlide key={expert.title}>
                  <DarkCardComponent
                    key={expert.title}
                    title={expert.title}
                    icon={<expert.icon style={{ color: "var(--purple_c)" }} />}
                    description={expert.description}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpertiseAreaPage;
